import { ChangeDetectionStrategy, Component, ElementRef, inject, input, ViewEncapsulation } from "@angular/core";

@Component({
    standalone: true,
    selector: "s25-ng-printable",
    template: `
        <div class="print-wrapper">
            <ng-content />
        </div>
    `,
    styles: `
        s25-ng-printable.hide {
            display: none;
        }

        @media print {
            :has(s25-ng-printable.printing) {
                padding: 0 !important;
                margin: 0 !important;

                :not(:has(s25-ng-printable.printing), s25-ng-printable.printing, s25-ng-printable.printing *) {
                    display: none !important;
                }

                s25-ng-printable.printing {
                    display: block;
                }

                s25-ng-printable.printing::before {
                    content: "";
                    position: fixed;
                    height: 100vh;
                    width: 100vw;
                    background: white;
                    top: 0;
                    left: 0;
                }

                s25-ng-printable.printing > .print-wrapper {
                    position: relative;
                }
            }
        }
    `,
    host: {
        "[class.hide]": "hidden()",
    },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class S25PrintableComponent {
    readonly hidden = input<boolean>(false);

    readonly elementRef = inject(ElementRef);

    print() {
        this.elementRef.nativeElement.classList.add("printing");
        window.print();
        this.elementRef.nativeElement.classList.remove("printing");
    }
}
